import { Observable, firstValueFrom } from "rxjs";
import { Document } from '@xanadu/model';
import { signal } from "@angular/core";

export abstract class Cache<T extends Document> {
    private _signal = signal<Map<string, T> | undefined>(undefined);

    constructor(
        protected readonly type: new (x: any) => T
    ) {
    }

    update(): void {
        if (this.load) {
            const map = new Map<string, T>();
            void firstValueFrom(this.load())
                .then(data => {
                    data.forEach(item => map.set(item._id!, item));
                    this._signal.set(map);
                });
        }
    }

    get signal(): typeof this._signal {
        const result = this._signal();
        if (!result) {
            this.update();
        }
        return this._signal;
    }

    protected abstract load(): Observable<T[]>;
}
